
import { FC, ReactNode, memo } from 'react';
import styles from './style.module.scss'


export const InvestmentBox: FC<ReactNode> = memo(({children}) => {
  return <div className={styles.block}>{children}</div>;
});

InvestmentBox.displayName = 'InvestmentBox';